import "@copilotkit/react-ui/styles.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@/styles/globals.scss';
import type { AppProps } from 'next/app';
import { Inter } from 'next/font/google';
import localFont from 'next/font/local';
import { SSRProvider } from 'react-bootstrap';
import dynamic from 'next/dynamic';
const GlobalProvider = dynamic(() => import('@/components/context/Global').then(mod => mod.GlobalProvider));

const inter = Inter({ subsets: ['latin'], variable: '--font-inter-tight', });

const PPNeueMontreal = localFont({
  src: [
    {
      path: '../fonts/pp-neue-montreal/PPNeueMontreal-SemiBolditalic.woff2',
      weight: '600',
      style: 'normal',
    },
    {
      path: '../fonts/pp-neue-montreal/PPNeueMontreal-Book.woff2',
      weight: '400',
      style: 'normal',
    },
    {
      path: '../fonts/pp-neue-montreal/PPNeueMontreal-Thin.woff2',
      weight: '100',
      style: 'normal',
    },
    {
      path: '../fonts/pp-neue-montreal/PPNeueMontreal-Thin.woff2',
      weight: '300',
      style: 'normal',
    },
    {
      path: '../fonts/pp-neue-montreal/PPNeueMontreal-Medium.woff2',
      weight: '500',
      style: 'normal',
    },
    {
      path: '../fonts/pp-neue-montreal/PPNeueMontreal-Bold.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
  variable: '--font-pp-neue',
  display: 'swap',
  preload: true,
});

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function App({ Component, pageProps }: AppProps) {

  return (
    <>
      <style jsx global>{`
        body {
          font-family: ${inter.style.fontFamily} !important;
          --primary-font: ${PPNeueMontreal.style.fontFamily};
        }
      `}</style>
      <SSRProvider>
        <GlobalProvider>
          <ToastContainer />
          <Component {...pageProps} />
        </GlobalProvider>
      </SSRProvider>
    </>
  );
}
